import {useContext} from "react";

import {CoeditorContext, type CoeditorState} from "./coeditor-context.ts";

/**
 * Hook providing access to external state of the Coeditor.
 */
export const useCoeditorContext = (): CoeditorState =>
    useContext(CoeditorContext);
